var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getInputStatus.error)?_c('div',{staticClass:"advice",on:{"click":_vm.close}},[_vm._l((_vm.adviceText),function(text,index){return _c('span',{key:index,staticClass:"advice__txt",style:({ animationDelay: index * 100 + 'ms' }),domProps:{"textContent":_vm._s(text)}})}),_c('i',{staticClass:"advice__ico"})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }